import {
  Accordion,
  AccordionDetail,
  AccordionHeader,
  AccordionItem,
  AccordionTitle
} from "@vds/accordions";
import { Icon } from "@vds/icons";
import { Loader } from "@vds/loaders";
import { Modal } from "@vds/modals";
import { Body } from "@vds/typography";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchVisionRulesEndPoint } from "../../../configuration";
import axiosInstance from "../../../global/axiosInterceptor";
import { formatTimeFrame, formatUTCTime } from "../../../global/utility/Utils";
import { CREATERULE_TEST_IDS } from "./createRuleConstants";

const RuleListModal = (props) => {
  const { id } = props;
  const { onClose } = props;
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const [fetchedRulesByDeviceid, setFetchRulesByDeviceid] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    const fetchRules = async () => {
      if (fetched) return; // Prevent multiple API calls
      try {
        setApiLoading(true);
        const accountId = activeSession.accountId;
        const response = await axiosInstance.post(fetchVisionRulesEndPoint(), {
          accountname: accountId,
          filter: {
            $selection: {
              deviceid: id ? id : "NA",
            },
          },
        });
        const fetchedRules = response.data;
        setFetchRulesByDeviceid(fetchedRules);
        setFetched(true);
      } catch (e) {
        console.error("Getting error while trying to fetch rules", e);
        return;
      } finally {
        setApiLoading(false);
      }
    };
    fetchRules();
  }, [props?.id]);

  return (
    <Modal
      id="alert-Modal"
      opened={true}
      width="360px"
      disableAnimation={false}
      disableOutsideClick={true}
      hideCloseButton={true}
      fullScreenDialog={false}
      closeButton={
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "25px",
            top: "25px",
          }}
          data-testid={CREATERULE_TEST_IDS.MODAL_CLOSE_BUTTON}
          onClick={() => {
            onClose();
          }}
        >
          <Icon name="close" />
        </div>
      }
    >
      <Body size="large">
        {apiLoading ? <Loader active fullscreen={false} surface="light" /> : ""}
        The following alerts are already applied to this ROI:
      </Body>

      <Accordion topLine={false}>
        {fetchedRulesByDeviceid?.length > 0 ? (
          fetchedRulesByDeviceid?.map((group) => {
            return (
              <AccordionItem key={group?.name}>
                <AccordionHeader triggerType="icon">
                  <AccordionTitle>
                    <Body size="large">{group?.name}</Body>
                  </AccordionTitle>
                </AccordionHeader>
                <AccordionDetail>
                  <div style={{ display: "flex" }}>
                    <Body size="small" bold>
                      Condition:{" "}
                    </Body>
                    <div style={{ marginLeft: "3px" }}>
                      <Body size="small">{group?.condition}</Body>
                    </div>
                  </div>

                  <br />

                  <div style={{ display: "flex" }}>
                    <Body size="small" bold>
                      Timeframe:
                    </Body>
                    <div style={{ marginLeft: "3px" }}>
                      <Body size="small">
                        {group?.timeFrame === "Always active" ||
                        group?.timeFrame?.length == ""
                          ? "Always active"
                          : formatTimeFrame(
                              formatUTCTime(group?.starttime)?.formatOnlyTime,
                              formatUTCTime(group?.endtime)?.formatOnlyTime,
                              group?.timeFrame
                            )}
                      </Body>
                    </div>
                  </div>

                  <br />

                  <div style={{ display: "flex" }}>
                    <Body size="small" bold>
                      Action:{" "}
                    </Body>
                    <div style={{ marginLeft: "3px" }}>
                      <Body size="small">{`Set severity to ${group?.severity} and alert ${group?.contactGroup}`}</Body>
                    </div>
                  </div>
                </AccordionDetail>
              </AccordionItem>
            );
          })
        ) : !apiLoading ? (
          <div style={{ marginTop: "30px" }}>
            <Body size="medium" bold>
              No alerts were added to this ROI
            </Body>
          </div>
        ) : (
          ""
        )}
      </Accordion>
    </Modal>
  );
};

export default RuleListModal;
